import { authHeader, handleResponse } from './helper';
import { getCookie } from './cookies';
import config from '../config';

export const getBranchOffices = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/branchOffices`);

  if (params) {
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  }

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getBranchOffice = async (id) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const response = await fetch(`${config.apiGeneralUrl}/branchOffices/${id}`, requestOptions).then(handleResponse);
  return Array.isArray(response) ? response[0] : response;
};

export const getBoxes = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  let endpoint = `${config.apiQueueManagementUrl}/boxes/get-boxes`;
  if (params) {
    const query = new URLSearchParams(params).toString();
    endpoint += `?${query}`;
  }
  return await fetch(endpoint, requestOptions).then(handleResponse);
};

export const getDepartments = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/departments`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getApplicants = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/users`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCompanies = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/companies`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCompany = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/companies/${params.id}`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const createCompany = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiGeneralUrl}/companies`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createUser = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/users`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateUser = async (id, params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/users/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getUser = async (id) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };
  const url = new URL(`${config.apiGeneralUrl}/users/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateCompany = async (id, params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiGeneralUrl}/companies/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getTributaryCompany = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/companies/getTributaryCompany`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getServices = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
      country_code: getCookie('country_code')
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/prestations`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCollections = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
      country_code: getCookie('country_code')
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/collections`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getBlocks = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: params.branchOffice || getCookie('branch_office_id'),
      country_code: getCookie('country_code'),
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/blocks/getBlocksByDate`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCommunes = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/communes`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getCostsCenters = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/costCenters`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCostCenter = async (id) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
  };
  const url = new URL(`${config.apiGeneralUrl}/costCenters/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createCostCenter = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/costCenters`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateCostCenter = async (id, params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/costCenters/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getChildCompanies = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/childCompanies`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getChildCompany = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/childCompanies/${params.id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateChildCompany = async (id, params) => {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/childCompanies/${id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createChildCompany = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/childCompanies`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getPaymentMethods = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/paymentMethods`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCountries = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/countries`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getGenders = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/gender`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getDoctors = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
      country_code: getCookie('country_code')
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/doctors`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getAsset = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    }
  };
  const url = new URL(`${config.apiGeneralUrl}/assets`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const uploadAsset = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/assets`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const uploadAssetS3 = async (file, s3Url) => {
  const requestOptions = {
    method: 'PUT',
    body: file,
  };
  const url = new URL(s3Url);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const removeAsset = async (params) => {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader()
    },
    body: JSON.stringify(params)
  };
  const url = new URL(`${config.apiGeneralUrl}/assets`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const downloadReport = async (params) => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
  };
  const url = new URL(`${config.apiGeneralUrl}/reports/getReport`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getDriverLicenses = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/driverLicenses`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getGlassesTypes = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/glassesTypes`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getApprovedTexts = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/consultationApprovedTexts`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getCurrency = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/currencies`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getEducationLevel = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      country_code: params.countryCode,
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiClinicalUrl}/general/educationLevel`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExams = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/exams`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getDiagnostics = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/diagnostics`);
  Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExamTypes = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/exams/types`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const getExamSpecialties = async () => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/exams/specialties`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const callPatient = async (params) => {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiQueueManagementUrl}/display/callPatient`);
  return await fetch(url, requestOptions).then(handleResponse);
};


export const getChangeStatus = async () => {
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiClinicalUrl}/medicalConsultation/changeStatus`);

  return await fetch(url, requestOptions).then(handleResponse);
};

export const getProjects = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/projects`);
  Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getProject = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };

  const url = new URL(`${config.apiGeneralUrl}/projects/${params.id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createProject = async (params) => {
  const requestOptions = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/projects`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const updateProject = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/projects/${params.id}`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getAreas = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/areas`);
  if (params) {
    Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getJobPositions = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/jobPositions`);
  if (params) {
    Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createArea = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/areas`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const createJobPosition = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(params),
  };

  const url = new URL(`${config.apiGeneralUrl}/jobPositions`);
  return await fetch(url, requestOptions).then(handleResponse);
}

export const getEvaluationTypes = async (params) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      country_code: getCookie('country_code'),
    }
  };

  const url = new URL(`${config.apiGeneralUrl}/evaluationTypes`);
  if (params) {
    Object.keys(params).forEach(key => params[key] && url.searchParams.append(key, params[key]));
  }
  return await fetch(url, requestOptions).then(handleResponse);
};